{
  "name": "@systemfsoftware/trigger.dev",
  "version": "2.3.19",
  "description": "A Command-Line Interface for Trigger.dev (v3) projects",
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/triggerdotdev/trigger.dev.git",
    "directory": "packages/cli-v3"
  },
  "publishConfig": {
    "access": "public"
  },
  "keywords": [
    "typescript",
    "trigger.dev",
    "workflows",
    "orchestration",
    "events",
    "webhooks",
    "integrations",
    "apis",
    "jobs",
    "background jobs",
    "nextjs"
  ],
  "files": [
    "dist"
  ],
  "type": "module",
  "exports": "./dist/index.js",
  "bin": {
    "triggerdev": "./dist/index.js"
  },
  "devDependencies": {
    "@systemfsoftware/trigger.dev_core-apps": "workspace:*",
    "@systemfsoftware/trigger.dev_tsconfig": "workspace:*",
    "@types/gradient-string": "^1.1.2",
    "@types/mock-fs": "^4.13.1",
    "@types/node": "^20.16.2",
    "@types/object-hash": "^3.0.6",
    "@types/react": "^18.2.48",
    "@types/semver": "^7.3.13",
    "@types/ws": "^8.5.3",
    "cpy-cli": "^5.0.0",
    "nodemon": "^3.0.1",
    "npm-run-all": "^4.1.5",
    "open": "^10.0.3",
    "p-retry": "^6.1.0",
    "rimraf": "^5.0.7",
    "tsup": "8.0.1",
    "type-fest": "^3.6.0",
    "typescript": "^5.3.3",
    "vitest": "^1.6.0",
    "xdg-app-paths": "^8.3.0"
  },
  "scripts": {
    "typecheck": "tsc -p tsconfig.check.json",
    "build": "npm run clean && run-p build:**",
    "build:main": "tsup",
    "build:workers": "tsup --config tsup.workers.config.ts",
    "build:prod-containerfile": "cpy --flat src/Containerfile.prod dist/",
    "dev": "npm run clean && run-p dev:**",
    "dev:main": "tsup --watch",
    "dev:workers": "tsup --config tsup.workers.config.ts --watch",
    "dev:test": "nodemon -w src/Containerfile.prod -x npm run build:prod-containerfile",
    "clean": "rimraf dist",
    "start": "node dist/index.js",
    "test": "vitest",
    "test:e2e": "vitest --run -c e2e/vite.config.js"
  },
  "dependencies": {
    "@anatine/esbuild-decorators": "^0.2.19",
    "@clack/prompts": "^0.7.0",
    "@depot/cli": "0.0.1-cli.2.71.0",
    "@opentelemetry/api": "^1.8.0",
    "@opentelemetry/api-logs": "^0.49.1",
    "@opentelemetry/exporter-logs-otlp-http": "^0.49.1",
    "@opentelemetry/exporter-trace-otlp-http": "^0.49.1",
    "@opentelemetry/instrumentation": "^0.49.1",
    "@opentelemetry/instrumentation-fetch": "^0.49.1",
    "@opentelemetry/resources": "^1.22.0",
    "@opentelemetry/sdk-logs": "^0.49.1",
    "@opentelemetry/sdk-node": "^0.49.1",
    "@opentelemetry/sdk-trace-base": "^1.22.0",
    "@opentelemetry/sdk-trace-node": "^1.22.0",
    "@opentelemetry/semantic-conventions": "^1.22.0",
    "@systemfsoftware/trigger.dev_core": "workspace:2.3.19",
    "@types/degit": "^2.8.3",
    "chalk": "^5.2.0",
    "chokidar": "^3.5.3",
    "cli-table3": "^0.6.3",
    "commander": "^9.4.1",
    "degit": "^2.8.4",
    "dotenv": "^16.4.4",
    "esbuild": "^0.19.11",
    "evt": "^2.4.13",
    "execa": "^9.1.0",
    "find-up": "^7.0.0",
    "glob": "^10.3.10",
    "gradient-string": "^2.0.2",
    "import-meta-resolve": "^4.0.0",
    "ink": "^4.4.1",
    "jsonc-parser": "3.2.1",
    "liquidjs": "^10.9.2",
    "mock-fs": "^5.2.0",
    "nanoid": "^4.0.2",
    "node-fetch": "^3.3.0",
    "object-hash": "^3.0.0",
    "p-debounce": "^4.0.0",
    "p-throttle": "^6.1.0",
    "partysocket": "^0.0.17",
    "proxy-agent": "^6.3.0",
    "react": "^18.2.0",
    "react-error-boundary": "^4.0.12",
    "semver": "^7.5.0",
    "simple-git": "^3.19.0",
    "source-map-support": "^0.5.21",
    "terminal-link": "^3.0.0",
    "tiny-invariant": "^1.2.0",
    "tsconfig-paths": "^4.2.0",
    "typescript": "^5.4.0",
    "update-check": "^1.5.4",
    "url": "^0.11.1",
    "ws": "^8.12.0",
    "zod": "3.22.3",
    "zod-validation-error": "^1.5.0"
  },
  "engines": {
    "node": ">=18.0.0"
  }
}
